import { type MotionValue } from 'motion/react'
import { observer } from 'mobx-react-lite'
import { type NotificationsSidebarViewModel } from '@/features/notifications/NotificationsSidebarViewModel'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
} from '@/components/StickyViewHeader'
import { WorkspaceSelectorViewHeadingContainer } from '@/features/iam/workspaces/components/WorkspaceSelectorViewHeading/WorkspaceSelectorViewHeadingContainer'

export interface NotificationsSidebarHeaderContainerProps {
  vm: NotificationsSidebarViewModel
  scrollOffset: MotionValue<number>
}

export const NotificationsSidebarHeaderContainer = observer(
  function NotificationsSidebarHeaderContainer({
    vm,
    scrollOffset,
  }: NotificationsSidebarHeaderContainerProps) {
    return (
      <StickyViewHeader scrollOffset={scrollOffset}>
        <StickyViewHeaderMain>
          <WorkspaceSelectorViewHeadingContainer
            value={vm.selectedWorkspace}
            onChange={vm.selectWorkspace}
            primaryText="Notifications"
            allOptionText="All Workspaces"
            workspaces={vm.workspaces}
            dropdownTitle="View notifications for"
          />
        </StickyViewHeaderMain>
      </StickyViewHeader>
    )
  },
)
